<div class="flex" [formGroup]="form">
    <label>{{label}}</label>
    <div>
        <input type="checkbox" [id]="id" class="checkbox" [formControlName]="id"/>
        <label [for]="id" class="toggle">
            <p>NO</p>
            <p>YES</p>
        </label>
    </div>
    
</div>
